import { createSlice } from '@reduxjs/toolkit';
import { UiState, UiState as UiStateEnum } from 'constants/ui';
import { transformUserStatsDto } from 'data/transformers/user-stats';
import { stateName } from './constants';
export const initialState = {
  requestState: UiState.Idle
};

const getUserStatsRequest = draft => {
  draft.requestState = UiStateEnum.Pending;
};

const getUserStatsFailure = draft => {
  draft.requestState = UiStateEnum.Failure;
};

const getUserStatsSuccess = (draft, action) => {
  const {
    stats
  } = action.payload;
  draft.stats = transformUserStatsDto(stats);
  draft.requestState = UiState.Success;
};

const setUnreadMsgCount = (draft, action) => {
  if (!draft.stats) return;
  const {
    count
  } = action.payload;
  draft.stats.unreadMsgCount = count;
};

const userStatsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getUserStatsRequest,
    getUserStatsFailure,
    getUserStatsSuccess,
    setUnreadMsgCount
  }
});
export const {
  actions
} = userStatsSlice;
export const plug = {
  [stateName]: userStatsSlice.reducer
};
export default userStatsSlice.reducer;